<template>
  <div class="empty-layout">
    <slot />
  </div>
</template>

<script>


export default {
  name: 'EmptyLayout',

  props: {
    background: {
      type: String,
      default: null
    }
  }
}
</script>
